import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { SmallTag } from '@/components/ui/Tag/SmallTag';
import { TagGroup } from '@/components/ui/Tag/TagGroup';
/**
 * 常見相談可、急募のタグをまとめて表示するためのコンポーネント
 * @param props
 * @constructor
 */
export const RfpProfessionalStatusesTagGroup = (props) => {
    const { className = '', isNegotiable, isUrgent } = props;
    return (_jsxs(TagGroup, Object.assign({ className: className }, { children: [isNegotiable && (_jsx(SmallTag, Object.assign({ color: 'positive', isKanjiTopFixed: true }, { children: "\u6761\u4EF6\u76F8\u8AC7\u53EF" }))), isUrgent && (_jsx(SmallTag, Object.assign({ color: 'negative', isKanjiTopFixed: true }, { children: "\u6025\u52DF" })))] })));
};
